// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"a8b0e4d7","83":"55061ec7","89":"909561e8","159":"6a974903","169":"fe330192","170":"ec50b5a2","243":"224547bd","270":"72c58870","357":"7bb1ec32","418":"b8f2d089","682":"7655ac15","736":"06fc1b13","793":"cbd3e036","894":"2a2c668d","925":"bd7da068"}[chunkId] + ".js";
};